import type { RoundScore } from '@/types/dde/teamHoleByHole.types'

import { GolfHoleByHoleHeader } from './GolfHoleByHoleHeader'
import { GolfHoleByHoleLegend } from './GolfHoleByHoleLegend'
import { GolfHoleByHoleRow } from './GolfHoleByHoleRow'
import { GolfHoleByHoleContainer, GolfHoleByHoleGrid, GolfHoleByHoleGridWrapper } from './styles'
import { ROW_HEADERS } from './utils'

interface GolfHoleByHoleProps {
  roundScores: { [key: string]: RoundScore }
  currentRound: number
}

export const GolfHoleByHole = ({ roundScores, currentRound }: GolfHoleByHoleProps) => {
  const [roundOne = null, roundTwo = null, roundThree = null, roundFour = null] =
    Object.values(roundScores)

  const currentRoundDataMap: Record<number, RoundScore | null> = {
    1: roundOne,
    2: roundTwo,
    3: roundThree,
    4: roundFour
  }

  return (
    <GolfHoleByHoleContainer>
      <GolfHoleByHoleLegend />
      <GolfHoleByHoleGridWrapper>
        <GolfHoleByHoleGrid>
          <GolfHoleByHoleHeader />
          <GolfHoleByHoleRow
            rowData={roundOne}
            rowHeader={ROW_HEADERS.ROUND_ONE}
            currentRound={currentRound}
            isScoreRow={true}
          />
          <GolfHoleByHoleRow
            rowData={roundTwo}
            rowHeader={ROW_HEADERS.ROUND_TWO}
            currentRound={currentRound}
            isScoreRow={true}
          />
          <GolfHoleByHoleRow
            rowData={roundThree}
            rowHeader={ROW_HEADERS.ROUND_THREE}
            currentRound={currentRound}
            isScoreRow={true}
          />
          <GolfHoleByHoleRow
            rowData={roundFour}
            rowHeader={ROW_HEADERS.ROUND_FOUR}
            currentRound={currentRound}
            isScoreRow={true}
          />
          <GolfHoleByHoleRow
            rowData={currentRoundDataMap[currentRound]}
            rowHeader={ROW_HEADERS.PAR}
            currentRound={currentRound}
            isScoreRow={false}
          />
          <GolfHoleByHoleRow
            rowData={currentRoundDataMap[currentRound]}
            rowHeader={ROW_HEADERS.YRD}
            currentRound={currentRound}
            isScoreRow={false}
          />
        </GolfHoleByHoleGrid>
      </GolfHoleByHoleGridWrapper>
    </GolfHoleByHoleContainer>
  )
}
